import { ActionTree } from "vuex";
import { ISDGState, ESDGActions, ESDGMutations } from "./sdg-rating.types";
import { RootState } from "@/services/store/root-state";
import { getBaseName } from "@/services/store/utils/get-base-name";
import { sdgReportProvider } from "@/modules/profile/services/data/sdg/sdg.provider";

export const actions: ActionTree<ISDGState, RootState> = {
  /**
   * Get the assessment history of a company.
   *
   * @param param0 store context
   * @param companyId Id of the company which the assessment history must
   * be fetched.
   */
  async [getBaseName(ESDGActions.FETCH)]({ commit }, companyId: number) {
    commit(ESDGMutations.SET_LOADING, true);
    commit(ESDGMutations.SET_ERROR, null);

    try {
      const data = await sdgReportProvider.getReport(companyId);
      const impactTargets = data.impact_scores
        .map((target) => ({
          target: target.sdg_target,
          netImpact: target.impact_net,
          impactPositive: target.impact_positive,
          impactNegative: target.impact_negative,
        }))
        .sort((a, b) => a.netImpact - b.netImpact);

      console.log("impactTargets", impactTargets);
      console.log({
        rating: data.ratings.impact_rating,
        score: data.ratings.impact_score,
        positiveImpact: data.ratings.impact_positive,
        negativeImpact: data.ratings.impact_negative,
        topPositivelyImpactedSDGs: impactTargets
          .slice(0, 5)
          .map((target) => target.target),
      });

      commit(ESDGMutations.SET_DATA, {
        rating: {
          rating: data.ratings.impact_rating,
          score: data.ratings.impact_score,
          positiveImpact: data.ratings.impact_positive,
          negativeImpact: data.ratings.impact_negative,
          topPositivelyImpactedSDGs: impactTargets
            .slice(0, 5)
            .map((target) => target.target),
        },
        impact: {},
      });
    } catch (error) {
      console.log("error", error);
      commit(ESDGMutations.SET_ERROR, error);
    } finally {
      commit(ESDGMutations.SET_LOADING, false);
    }
  },
};
